import {
  Component,
  OnInit,
  OnDestroy,
  signal,
  inject,
  computed,
  WritableSignal,
  effect,
  ChangeDetectionStrategy,
} from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { CoreService, NotificationService } from '../../services'
import { checkoutsColumns, printSaleExportsColumns } from '../../utils/definitions.util'
import { SchemaUtil } from '../../utils'
import { TranslateService } from '@ngx-translate/core'
import { injectInfiniteQuery } from '@tanstack/angular-query-experimental'
import { SaleExportService } from '../../services/entity-services/saleExport.service'

const DEFAULT_FILTERS = {
  // sortProp: 'created',
  // sortDir: 'desc',
}

@Component({
  selector: 'app-print-sale-exports',
  templateUrl: 'print-sale-exports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrintSaleExportsComponent extends BaseListing implements OnInit, OnDestroy {
  private saleExportService = inject(SaleExportService)

  listingColumns = signal(printSaleExportsColumns)
  reports: any[] = []
  totalItems = computed(() => {
    console.error(this.queryPrintSaleExports.data())
    return 100
  })
  currentPage: number
  endPage: number
  // filters = { ...DEFAULT_FILTERS }
  refreshInterval: any = null
  loading = true
  // storageKey: WritableSignal<{ type: string; key: string }> = signal({ type: '', key: '' })
  sortProp = signal('created')
  sortDir = signal('desc')

  readonly queryPrintSaleExports = injectInfiniteQuery(() => ({
    queryKey: ['printSaleExports', { sortProp: this.sortProp(), sortDir: this.sortDir() }], // todo add  queryKey -> sort, filters, schema - columns
    queryFn: async ({ pageParam }) => {
      // const requestId = ++this.currentRequestId // unique ID per call
      return await this.saleExportService
        .getSaleExports(
          {
            page: pageParam,
            sort: this.sortProp(),
            direction: this.sortDir(),
          },
          SchemaUtil.sale
        )
        .then(result => {
          return result
        })
    },
    initialPageParam: 1,
    getNextPageParam: result => {
      return Number(result?.paginator?.current) < Number(result?.paginator?.endPage)
        ? Number(result?.paginator?.current) + 1
        : undefined
    },
  }))
  constructor(
    protected core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {
    super(core)
    effect(() => {
      this.queryPrintSaleExports.data()
    })
    // this.getStorageKey()
  }

  ngOnInit() {
    // this.filters = this.loadViewSettings('printSaleExports') || { ...DEFAULT_FILTERS }
    this.loadSorting('printSaleExports')
    // this.filter()
  }

  ngOnDestroy() {
    this.stopRefreshing()
  }

  async createExportSales(salesExport) {
    this.loading = true
    try {
      this.startRefreshing('queryPrintSaleExports')
      await this.core.services.saleExport.create(salesExport, { id: null }).then(() => {
        this.notificationService.success(this.translateService.instant('alert.sale.created'))
      })
      this.queryPrintSaleExports.refetch()
    } catch (err) {
      console.error(err)
    } finally {
      this.loading = false
      // this.reloading = false
    }
  }

  downloadReport(report: any) {
    this.core.services.download.downloadDocumentAndShowInNewWindow(report.url)
  }
}
